import datapoints from '../datapoints';
import { action } from 'satcheljs/lib/legacy';
import { ClientItem, mailStore } from 'owa-mail-store';

export default action('untranslateItem', datapoints.InlineTranslationMessageUntranslated)(
    function untranslateItem(item: ClientItem) {
        const conversationId = item.ConversationId.Id;
        const conversationItemParts = mailStore.conversations.get(conversationId);
        conversationItemParts.subjectTranslationData.isShowingTranslation = false;
        item.TranslationData.isShowingTranslation = false;
    }
);
